export default {
    computed: {
        isTouch () {
            return 'ontouchstart' in window || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        },
        urlCoords () {
            return this.coords.replace(/:/g, '-');
        }
    },
    methods: {
        getEcoColor (sub) {
            if (!sub) return;
            return this.$root.shared.economyTypes.find(e => {
                return e.subs.includes(sub);
            }).color;
        },
        getEcoIcon (sub) {
            if (!sub) return;
            return this.$root.shared.economyTypes.find(e => {
                return e.subs.includes(sub);
            }).icon;
        },
        getEcoTier (sub) {
            if (!sub) return;
            return this.$root.shared.economyLevels.find(l => {
                return l.subs.includes(sub);
            }).tier;
        },
        getEcoCategory (sub) {
            if (!sub) return;
            return this.$root.shared.economyTypes.find(e => {
                return e.subs.includes(sub);
            }).title;
        },
        textColor (bgColor) {
            const hex = bgColor.replace(/#/, '');
            const r = parseInt(hex.substr(0, 2), 16);
            const g = parseInt(hex.substr(2, 2), 16);
            const b = parseInt(hex.substr(4, 2), 16);

            const luma = [
                0.299 * r,
                0.587 * g,
                0.114 * b
            ].reduce((a, b) => a + b) / 255;

            return luma > 0.5 ? '#000000' : '#ffffff';
        },
        onlyHex (val) {
            return val.replace(/[^0-9a-fA-F]/g, '').substr(0, 16);
        }
    }
};
